import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import PortfolioForm from '../../components/Portfolios/PortfolioForm';
import portfolioService from '../../services/portfolioService';

const PortfolioEdit = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [portfolio, setPortfolio] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchPortfolio();
  }, [id]);

  const fetchPortfolio = async () => {
    try {
      setLoading(true);
      const data = await portfolioService.getPortfolioById(id);
      setPortfolio(data.portfolio);
      setError(null);
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to fetch portfolio');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="page-container">
        <div className="loading">Loading portfolio...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="page-container">
        <div className="alert alert-danger">{error}</div>
        <button onClick={() => navigate('/app/portfolios')} className="btn btn-secondary">
          Back to Portfolios
        </button>
      </div>
    );
  }

  return (
    <div className="page-container">
      <div className="page-header">
        <button onClick={() => navigate('/app/portfolios')} className="back-button">
          <i className="fas fa-arrow-left"></i> Back to Portfolios
        </button>
        <h1>Edit Portfolio</h1>
      </div>
      <PortfolioForm portfolioId={id} initialData={portfolio} />
    </div>
  );
};

export default PortfolioEdit;

